import { computed, ComputedRef, ref } from 'vue'

const show = ref(false)

export function useShowBattersAndBowlerSwitch(): {
  toggleBattersAndBowlerInfoVisibility: () => void
  showBattersAndBowlerInfo: ComputedRef<boolean>
} {
  function toggleBattersAndBowlerInfoVisibility(): void {
    show.value = !show.value
  }

  return {
    toggleBattersAndBowlerInfoVisibility,
    showBattersAndBowlerInfo: computed(() => show.value),
  }
}
